import React from "react";
import { Box, Switch, Tooltip, IconButton, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { gray } from "../../../theme/themePrimitives";

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

export const FileHubEmailNotificationToggle: React.FC<Props> = ({
  checked,
  onChange,
  disabled,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #EAECF0",
        borderRadius: "12px",
        bgcolor: "white",
        padding: "12px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 2,
        boxShadow: "0px 1px 3px 0px #1018281A",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography sx={{ color: "#101828", fontWeight: 400, fontSize: 16 }}>
          Subscribe to email notification
        </Typography>

        <Tooltip
          title="Get notified by email when any file is uploaded to File Hub"
          placement="right"
          slotProps={{
            tooltip: {
              sx: {
                bgcolor: "#1F2937",
                color: "#fff",
                fontSize: "14px",
                borderRadius: "8px",
                padding: "8px 12px",
              },
            },
          }}
        >
          <IconButton
            size="small"
            sx={{
              color: gray[500],
              border: "none",
              "&:hover": {
                bgcolor: "transparent",
              },
            }}
            aria-label="Subscribe info"
          >
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
    </Box>
  );
};
